import {writable} from "../../_snowpack/pkg/svelte/store.js";
const initialData = JSON.parse(localStorage.getItem("groupedCategories"));
export const groupedCategories = writable(initialData);
groupedCategories.subscribe((value) => localStorage.groupedCategories = JSON.stringify(value));
